import React, { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { Loading } from "../../components";
import useRouting from "../../contexts/Routing";
import useCurrentSession from "../../contexts/UserContext";
import "./Homepage.css";

export default function Homepage() : ReactElement | null {
    const { getSearchParams, Paths, historyPush } = useRouting();

    const { redirect, isWaitLogin } = getSearchParams(Paths.HOME);
    const session = useCurrentSession();
    if (redirect) {
        if (session.isLoggedIn) {
            return <Navigate to={redirect} />;
        } if (isWaitLogin === "true") {
            return <Loading />;
        }
    }
    historyPush(Paths.ANSWERS_LIST);
    return null;
}
